import { createAction } from '@reduxjs/toolkit';
import { body } from './NewTenant';

export const fetchAppTypes = createAction('FETCH_APP_TYPES');
export const putAppTypes = createAction<any>('PUT_APP_TYPES');
export const fetchLocales = createAction('FETCH_LOCALES');
export const putLocales  = createAction<any>('PUT_LOCALES');
export const submitTenants = createAction<body>('SUBMIT_TENANT');
export const tenantAdded = createAction('TENANT_ADD_SUCCESS');
export const tenantAdditionFailed = createAction('TENANT_ADD_FAILED');